export const Url = 'url'
export const Text = 'text'
export const Search = 'search'
export const Number = 'number'
